import { useQuery } from '@apollo/client';
import { graphql } from '../../__generated__';
import { Fulfillment } from '../../__generated__/graphql';
import { useEffect } from 'react';
// @ts-ignore
import { pusherSubscribeObject } from '../../Common/utils/pusher';
import { usePortalPermissions } from '../../Common/hooks/usePortalPermissions';

export const pendingDispenseQuery = graphql(`
  query pendingDispense {
    fulfilmentsPendingDispense {
      id
      createdAt
      total
      dispensed
      completed
      consults
      gateway
      booked
      subtotal
      shipping
      discounts
      discountCodes
      items {
        QTY
        ID
        PrescriptionID
      }
      street
      suburb
      state
      postcode
      total
      suburb
      prescriptionIDs
      creatingRole
      creatingRole
      deliveryMethod
      customer {
        id
        given
        dob
        brand
        mobile
        name
      }
      __typename
    }
  }
`);

export const usePendingDispenseList = () => {
  const { hasPermission } = usePortalPermissions();

  const { data, loading, refetch } = useQuery(pendingDispenseQuery, {
    fetchPolicy: 'cache-and-network',
    skip: !hasPermission('fulfill'),
  });

  useEffect(() => {
    const { unsubscribe } = pusherSubscribeObject('fulfillment', 'new', () => refetch());

    return () => {
      unsubscribe();
    };
  }, []);

  return {
    loading,
    count: data?.fulfilmentsPendingDispense?.length ?? 0,
    orders: (data?.fulfilmentsPendingDispense ?? []) as Fulfillment[],
    refetch,
  };
};
